"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortRelatedEpisodes = exports.sortRelatedClips = exports.removeDuplicatePrograms = void 0;
var removeDuplicatePrograms = function (programs) {
    return programs.filter(function (program, index, array) { return index === array.findIndex(function (_a) {
        var guid = _a.guid;
        return program.guid === guid;
    }); });
};
exports.removeDuplicatePrograms = removeDuplicatePrograms;
var sortRelatedClips = function (currentPlaylist, programs) {
    var tvSeasonEpisodeNumber = currentPlaylist[0].tvSeasonEpisodeNumber;
    var sortedPlaylist = programs.sort(function (programA, programB) {
        if (programA.tvSeasonEpisodeNumber === programB.tvSeasonEpisodeNumber)
            return 0;
        if (programA.tvSeasonEpisodeNumber === tvSeasonEpisodeNumber)
            return -1;
        if (programB.tvSeasonEpisodeNumber === tvSeasonEpisodeNumber)
            return 1;
        return 0;
    });
    var result = (0, exports.removeDuplicatePrograms)(__spreadArray(__spreadArray([], currentPlaylist, true), sortedPlaylist, true)).slice(0, 10);
    return result;
};
exports.sortRelatedClips = sortRelatedClips;
var sortRelatedEpisodes = function (currentPlaylist, programs) {
    var tvSeasonEpisodeNumber = currentPlaylist[0].tvSeasonEpisodeNumber;
    var sortedPlaylist = programs
        .sort(function (programA, programB) {
        if (!programA.tvSeasonEpisodeNumber || !programB.tvSeasonEpisodeNumber)
            return 0;
        return programA.tvSeasonEpisodeNumber - programB.tvSeasonEpisodeNumber;
    })
        .filter(function (program) {
        if (!tvSeasonEpisodeNumber || !program.tvSeasonEpisodeNumber)
            return false;
        return tvSeasonEpisodeNumber <= program.tvSeasonEpisodeNumber;
    });
    var result = (0, exports.removeDuplicatePrograms)(__spreadArray(__spreadArray([], currentPlaylist, true), sortedPlaylist, true)).slice(0, 10);
    return result;
};
exports.sortRelatedEpisodes = sortRelatedEpisodes;
